import { PROTECTION_MINIMAL_COVERAGE } from '@utils/protection_plan';

export type ReservationSummaryProps = {
  summaryLoaded: boolean;
  storagePlanLabel: string;
  storagePlanTax: number;
  storagePlanAmount: number;
  monthlyTotalAmount: number;
  protectionPlanLabel: string;
  protectionPlanTax: number;
  protectionPlanAmount: number;
  /**
   * Month-to-month storage rate before term discount (storage rent only). When set and above
   * `monthlyTotalAmount`, shown struck-through next to the member’s rate (funnel summary).
   */
  monthlyStorageCompareAtAmount?: number;
};

export const DEFAULT_RESERVATION_SUMMARY_PROPS: ReservationSummaryProps = {
  summaryLoaded: false,
  storagePlanTax: 0,
  storagePlanAmount: 0,
  protectionPlanTax: 0,
  monthlyTotalAmount: 0,
  storagePlanLabel: '',
  protectionPlanAmount: PROTECTION_MINIMAL_COVERAGE.cost,
  protectionPlanLabel: PROTECTION_MINIMAL_COVERAGE.label,
  monthlyStorageCompareAtAmount: undefined,
};
